import {Event} from "../../../types/eventTypes"
import StyledPopup from "../../CommonComponents/StyledPopup/StyledPopup";
import Tracksform from "../../MatchboardContent/EventForm/Tracksform";
import React, {useEffect, useState} from "react";
import {Stream, Track} from "../../../types/dataSourceTypes";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";
import {Dayjs} from "dayjs";
import {Collapse} from "@mui/material";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import {fillEvent} from "../../../queries/matchPageQueries";
import StreamDataSourceForm from "../../MatchboardContent/EventForm/StreamDataSourceForm";
import JobForm from "../../MatchboardContent/JobForm/JobForm";
import {SimpleFileDataSource, LoadError} from "../../../types/generic";
import ErrorSnackBar from "../../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {a11yProps} from "../../../utils/utils"
import CustomTabPanel from "../../CommonComponents/CustomTabPanel/CustomTabPanel";
import Grid from "@mui/material/Grid";
import {Competition, defaultCompetition} from "../../CommonComponents/OpenerCloserComponent/OpenerCloserComponent";
import {FormJob} from "../../../types/jobTypes";
import SpinnerBox from "../../CommonComponents/SpinnerBox/SpinnerBox";

interface FillEventPopupProps {
    isOpen: boolean;
    handleClose: () => void;
    streamTracks: Track[];
    fileTracks: Track[];
    typeMediaTrack: string[];
    updateStreamTracks : (nameDS:  keyof Track,  value: string | null, indexTrack: number) => void;
    updateFileTracks : (nameDS:  keyof Track,  value: string | null, indexTrack?: number) => void;
    streamDataSource : Stream;
    fileDataSource : SimpleFileDataSource;
    protocolOptions: string[];
    updateStreamDataSource: (nameDS:  keyof Stream,  value: string | Dayjs | null | boolean, indexTrack?: number) => void;
    onAddStreamTrack: () => void;
    onAddFileTrack: () => void;
    onRemoveStreamTrack: (trackIndex: number) => void;
    onRemoveFileTrack: (trackIndex: number) => void;
    job: FormJob;
    setJob: React.Dispatch<React.SetStateAction<FormJob>>,
    isJobFormOpen: boolean;
    onJobSubmit: () => void;
    isEventFormOpen: boolean;
    setEventReady: () => void;
    event: Event,
    updateFileDataSource: (field: keyof SimpleFileDataSource, value: string) => void;
    popUpTitle: string;
    dataSourcesLoading: boolean;
}

const FillEventPopup: React.FC<FillEventPopupProps> = ({dataSourcesLoading, setJob, popUpTitle, event,updateFileDataSource, fileDataSource, setEventReady, isEventFormOpen, onJobSubmit, isJobFormOpen, job, onAddStreamTrack, onAddFileTrack, onRemoveStreamTrack, onRemoveFileTrack, updateStreamDataSource, protocolOptions, streamDataSource, isOpen, handleClose, fileTracks, streamTracks, typeMediaTrack, updateStreamTracks, updateFileTracks
                                                       }) => {

    const theme = useTheme();
    const [streamingUrl, setStreamingUrl] = useState<string>("");
    const [filePath, setFilePath] = useState<string>("");
    const [moreInfoOpen, setMoreInfoOpen] = useState<boolean>(false);
    const [fileMoreInfoOpen, setFileMoreInfoOpen] = useState<boolean>(false);
    const [loadError, setLoadError] = useState<LoadError>({message: '', error: false});
    const [currentTab, setCurrentTab] = React.useState<number>(0);
    const [jobCompetition, setJobCompetition] = useState<Competition>(defaultCompetition)

    useEffect(() => {
        if (streamDataSource){
            setStreamingUrl(streamDataSource.url);
        }
    }, [streamDataSource.url]);

    useEffect(() => {
        if(fileDataSource){
            setFilePath(fileDataSource.path);
        }
    }, [fileDataSource.path]);

    useEffect(() => {

        if(event && event.competition) {
            setJobCompetition({name: event.competition.name, id: event.competition.id, type: "", season: ""})
        } else {
            setJobCompetition(defaultCompetition)
        }

    }, [event]);

    useEffect(() => {
        if (streamDataSource && streamDataSource.pushPullButton) {
            setStreamingUrl(streamDataSource.url);
        }
    }, [streamDataSource.pushPullButton]);

    async function backendUpdateTracks(){
        try{
            await fillEvent(streamDataSource, streamingUrl, streamTracks, fileDataSource, filePath, fileTracks, event);
            const isStreamDataSourceReady = (streamingUrl || streamDataSource.pushPullButton) && streamTracks.find(track => track.typeTrack === 'video')
            const isFileDataSourceReady = filePath && fileTracks.find(track => track.typeTrack === 'video')
            if (isStreamDataSourceReady || isFileDataSourceReady){
                setEventReady();
                updateStreamDataSource('url', streamingUrl);
                updateFileDataSource('path', filePath)
            }
        }catch (e){
            setLoadError({error: true, message: 'Error Updating Event Datasource'});
        }finally {
            onClose();
        }
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    function onClose(){
        handleClose();
        setStreamingUrl("");
        setFilePath("");
    }

    return(


            <StyledPopup title={popUpTitle} isOpen={isOpen} onClose={onClose} width={!isJobFormOpen ? '50vw' : '70%'}>
                {isJobFormOpen && <Box sx={{marginTop: theme.spacing.md}}>
                    <JobForm
                        eventId={event.id}
                        job={job}
                        onSubmit={onJobSubmit}
                        setJob={setJob}
                        mode={'create'}
                        competition={jobCompetition}
                    />
                </Box>}
                {isEventFormOpen && !isJobFormOpen  && !dataSourcesLoading &&
                    <Box>
                        <Tabs
                            value={currentTab}
                            onChange={handleTabChange}
                            aria-label="playlist tabs"
                            sx={{
                                '& .MuiTab-root': { color: theme.palette.white, fontSize: theme.fontSizes.title, fontWeight: theme.fontWeights.title, paddingTop: 0, paddingBottom: 0},
                                '& .Mui-selected': { color: theme.palette.orange + ' !important', fontWeight: theme.fontWeights.title },
                                '& .MuiTabs-indicator': { backgroundColor: theme.palette.orange }
                            }}
                        >
                            <Tab label="Stream" {...a11yProps(0)} />
                            <Tab label="File" {...a11yProps(1)} />
                        </Tabs>
                        <CustomTabPanel value={currentTab} index={0}>
                            <Box sx={{marginTop: theme.spacing.md, marginBottom: theme.spacing.md}}>
                                <TextinputField
                                    value={streamingUrl}
                                    disabled={streamDataSource.pushPullButton}
                                    name={'Stream URL'}
                                    label={'Stream URL'}
                                    placeholder={"Insert stream url"}
                                    type={'text'}
                                    variant={'outlined'}
                                    color={theme.palette.white}
                                    borderColor={theme.palette.white}
                                    borderRadius={theme.border.width.hard}
                                    size={'medium'}
                                    onChange={(e) => setStreamingUrl(e.target.value)}
                                    width={'100%'}
                                />
                            </Box>
                            <Box>
                                <TransparentButton onClick={onAddStreamTrack} text={'Add Track'}></TransparentButton>
                                {streamTracks.map((track, index) => (
                                    <Box key={"restrinct-trackForm" + index} sx={{marginTop: theme.spacing.md}}>
                                        <Tracksform
                                            handleChangeTrack={updateStreamTracks}
                                            tracks={track}
                                            index={index}
                                            typeMediaTrack={typeMediaTrack}
                                            onRemoveTrack={onRemoveStreamTrack}
                                        />
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{paddingTop: theme.spacing.md, paddingBottom: theme.spacing.md}}>
                                <TransparentButton text={'MORE INFO'} onClick={() => setMoreInfoOpen((moreInfoOpen) => !moreInfoOpen)}/>
                            </Box>
                            {<Collapse in={moreInfoOpen}>
                                <StreamDataSourceForm
                                    stream={streamDataSource}
                                    protocol={protocolOptions}
                                    updateStreamDataSource={updateStreamDataSource}
                                    displayUrl={false}
                                    displayNameAndDescription={true}
                                    needPadding={false}
                                    handleTrackChange={updateStreamTracks}
                                />
                            </Collapse>}
                        </CustomTabPanel>
                        <CustomTabPanel value={currentTab} index={1}>
                            <Box sx={{marginTop: theme.spacing.md, marginBottom: theme.spacing.md}}>
                                <TextinputField
                                    value={filePath}
                                    name={'filePath'}
                                    label={'S3 Path'}
                                    placeholder={"Insert S3 path"}
                                    type={'text'}
                                    variant={'outlined'}
                                    color={theme.palette.white}
                                    borderColor={theme.palette.white}
                                    borderRadius={theme.border.width.hard}
                                    size={'medium'}
                                    onChange={(e) => setFilePath(e.target.value)}
                                    width={'100%'}
                            /></Box>
                            <TransparentButton onClick={onAddFileTrack} text={'Add Track'}></TransparentButton>
                            {fileTracks.map((track, index) => (
                                <Box key={"restrinct-filetrackForm" + index} sx={{marginTop: theme.spacing.md}}>
                                    <Tracksform
                                        handleChangeTrack={updateFileTracks}
                                        tracks={track}
                                        index={index}
                                        typeMediaTrack={typeMediaTrack}
                                        onRemoveTrack={onRemoveFileTrack}
                                    />
                                </Box>
                            ))}
                            <Box sx={{paddingTop: theme.spacing.md, paddingBottom: theme.spacing.md}}>
                                <TransparentButton text={'MORE INFO'} onClick={() => setFileMoreInfoOpen((moreInfoOpen) => !moreInfoOpen)}/>
                            </Box>
                            {<Collapse in={fileMoreInfoOpen}>
                                <Grid container spacing={2}>
                                    <Grid item sm={12} md={6}>
                                        <TextinputField
                                            value={fileDataSource.name}
                                            name={'Name'}
                                            label={'Name'}
                                            placeholder={"Insert Datasource Name"}
                                            type={'text'}
                                            variant={'outlined'}
                                            color={theme.palette.white}
                                            borderColor={theme.palette.white}
                                            borderRadius={theme.border.width.hard}
                                            size={'medium'}
                                            onChange={(e) => updateFileDataSource('name',e.target.value)}
                                            width={'100%'}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <TextinputField
                                            value={fileDataSource.description}
                                            name={'description'}
                                            label={'Description'}
                                            placeholder={"Insert Datasource description"}
                                            type={'text'}
                                            variant={'outlined'}
                                            color={theme.palette.white}
                                            borderColor={theme.palette.white}
                                            borderRadius={theme.border.width.hard}
                                            size={'medium'}
                                            onChange={(e) => updateFileDataSource('description', e.target.value)}
                                            width={'100%'}
                                        />
                                    </Grid>
                                </Grid>

                            </Collapse>}
                        </CustomTabPanel>
                        <Box display="flex" justifyContent="center" sx={{marginTop: theme.spacing.md}}>
                            <TransparentButton
                                text={'Save'}
                                onClick={backendUpdateTracks}
                                disabled={!(Boolean((streamingUrl || streamDataSource.pushPullButton)  && streamTracks.find(track => track.typeTrack === 'video')) || Boolean(filePath && fileTracks.find(track => track.typeTrack === 'video')))}
                                width={'100px'}
                            />
                        </Box>
                    </Box>
                }
                {isEventFormOpen && !isJobFormOpen && dataSourcesLoading && <SpinnerBox text="Loading Event Infos…" spinnerSize={40} height={'70vh'}/>}
                <ErrorSnackBar autoHideDuration={10000} open={loadError.error} setClose={() => setLoadError({message:'', error: false})} errorMessage={loadError.message}/>
        </StyledPopup>

    )
}
export default FillEventPopup;